import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import { authClient } from '../lib/auth-client';
import { clearHadSession } from '../lib/sessionDiagnostics';
import { getAuthToken } from '../lib/platform';
import { unregisterPush } from '../lib/push';

export const useLogout = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async () => {
      // Native push cleanup (a no-op on web). Started BEFORE signOut, because
      // deleting the device token needs the session signOut revokes, and never
      // awaited: it must not delay or fail a sign-out.
      getAuthToken().then(unregisterPush).catch(() => undefined);
      await authClient.signOut({
        fetchOptions: {
          onSuccess: () => {
            navigate('/sign-in');
          },
        },
      });
    },
    onSuccess: () => {
      // Clear all React Query cache to prevent data leakage between users
      queryClient.clear();
      clearHadSession();

      // Navigate to sign-in page after logout
      navigate('/sign-in');
    },
    onError: () => {
      // Clear cache even on error - session may have been cleared
      queryClient.clear();
      clearHadSession();

      // Navigate anyway - session may have been cleared
      navigate('/sign-in');
    },
  });
};
